import { render, staticRenderFns } from "./PaymentHistoryTable.vue?vue&type=template&id=dc994936&scoped=true&"
import script from "./PaymentHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./PaymentHistoryTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc994936",
  null
  
)

export default component.exports